import type { QueryKeyData, QueryParams } from '@pba/react-query';
import { useQuery } from '#react-query';
import { type ChatroomStatsResponse, getChatroomStats } from '../../services';
import { getChatroomStatsQueryKey } from './keys';

export type ChatroomStatsQueryData = QueryKeyData<ChatroomStatsResponse, typeof getChatroomStatsQueryKey>;
export type GetChatroomStatsParams = QueryParams<ChatroomStatsQueryData>;

export const useGetChatroomStats = ({ options }: Pick<GetChatroomStatsParams, 'options'> = {}) =>
  useQuery({
    async queryFn() {
      const { data } = await getChatroomStats();

      return data;
    },
    queryKey: getChatroomStatsQueryKey(),
    throwOnError: false,
    ...options,
  });
